/* Onestrap theme — interactions ported from the landing mock, wired to the
   Shopify AJAX cart. No dependencies. */
(function () {
  "use strict";

  var O = window.Onestrap || {};
  var doc = document;
  var $ = function (s, r) {
    return (r || doc).querySelector(s);
  };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || doc).querySelectorAll(s));
  };
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- currency: shop amounts (GBP) shown in the shopper's currency ----------
     Kaching and the theme settings quote prices in the shop currency. Shopify converts at
     Shopify.currency.rate and the bundle discount rounds to the cent, so the same is done here.
     [data-fx="2900"]            → base cents converted (optional data-fx-minus = cents already
                                   in the shopper's currency, data-fx-div = divide the result)
     [data-fx-text]              → every "£12.50" inside the text is converted */
  var FX = (function () {
    var c = window.Shopify && window.Shopify.currency;
    if (!c || !O.baseCurrency || c.active === O.baseCurrency) return null;
    return { rate: +c.rate || 1, cur: c.active };
  })();
  var FX_LOCALE = {
    GBP: "en-GB",
    USD: "en-US",
    CAD: "en-CA",
    AUD: "en-AU",
    NZD: "en-NZ",
    EUR: "en-IE",
  };
  function fxCents(base) {
    return Math.round(FX ? base * FX.rate : base);
  }
  function fxMoney(cents) {
    try {
      return new Intl.NumberFormat(FX_LOCALE[FX.cur] || "en", {
        style: "currency",
        currency: FX.cur,
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function fxApply(root) {
    if (!FX) return;
    $$("[data-fx]", root).forEach(function (el) {
      var v = fxCents(+el.dataset.fx) - (+el.dataset.fxMinus || 0);
      el.textContent = fxMoney(Math.round(v / (+el.dataset.fxDiv || 1)));
    });
    $$("[data-fx-text]", root).forEach(function (el) {
      if (el.dataset.fxDone) return;
      el.dataset.fxDone = "1";
      var walker = doc.createTreeWalker(el, NodeFilter.SHOW_TEXT),
        node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf("£") < 0) continue;
        node.nodeValue = node.nodeValue.replace(
          /£\s?(\d+(?:\.\d{1,2})?)/g,
          function (m, n) {
            return fxMoney(fxCents(parseFloat(n) * 100));
          },
        );
      }
    });
  }
  fxApply(doc);

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $("#Toast");
    if (!t) return;
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      t.classList.remove("show");
    }, 2400);
  }

  /* ---------- fixed top bar height → --top ---------- */
  var topbar = $("#TopBar");
  function syncTop() {
    if (topbar)
      doc.documentElement.style.setProperty(
        "--top",
        topbar.offsetHeight + "px",
      );
  }
  syncTop();
  if (topbar && "ResizeObserver" in window)
    new ResizeObserver(syncTop).observe(topbar);

  /* ---------- reveal on scroll ---------- */
  var io =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (es) {
            es.forEach(function (e) {
              if (e.isIntersecting) {
                e.target.classList.add("in");
                io.unobserve(e.target);
              }
            });
          },
          { rootMargin: "0px 0px -10% 0px", threshold: 0.06 },
        )
      : null;
  function observeReveal(root) {
    $$(".rv:not(.in)", root).forEach(function (el) {
      io ? io.observe(el) : el.classList.add("in");
    });
  }

  /* ---------- counters ---------- */
  var cio =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (es) {
            es.forEach(function (e) {
              if (!e.isIntersecting) return;
              cio.unobserve(e.target);
              var to = +e.target.dataset.count,
                t0 = performance.now(),
                dur = 1100;
              (function step(now) {
                var p = Math.min(1, (now - t0) / dur),
                  eased = 1 - Math.pow(1 - p, 3);
                e.target.textContent = Math.round(to * eased);
                if (p < 1) requestAnimationFrame(step);
              })(t0);
            });
          },
          { threshold: 0.6 },
        )
      : null;
  function observeCounters(root) {
    if (!cio || reduced) return;
    $$("[data-count]", root).forEach(function (el) {
      cio.observe(el);
    });
  }

  /* ---------- lazy looping videos ---------- */
  var vio =
    "IntersectionObserver" in window && !reduced
      ? new IntersectionObserver(
          function (es) {
            es.forEach(function (e) {
              var v = e.target;
              var play = function () {
                var p = v.play();
                if (p && p.catch) p.catch(function () {});
              };
              if (e.isIntersecting) {
                if (!v.dataset.loaded) {
                  v.dataset.loaded = "1";
                  v.addEventListener("loadeddata", play, { once: true });
                  v.src = v.dataset.src;
                  v.load();
                } else play();
              } else v.pause();
            });
          },
          { rootMargin: "300px 0px", threshold: 0.15 },
        )
      : null;
  function observeVideos(root) {
    if (!vio) return;
    $$("video[data-src]", root).forEach(function (v) {
      vio.observe(v);
    });
  }

  /* ---------- gallery ---------- */
  function initGallery(root) {
    $$("[data-gallery]", root).forEach(function (g) {
      var stage = $("[data-stage]", g) || $(".stage img", g);
      $$(".thumbs button", g).forEach(function (b) {
        b.addEventListener("click", function () {
          $$(".thumbs button", g).forEach(function (x) {
            x.classList.remove("on");
          });
          b.classList.add("on");
          if (!stage) return;
          stage.removeAttribute("srcset");
          if (b.dataset.srcset) stage.srcset = b.dataset.srcset;
          stage.src = b.dataset.src;
          stage.alt = b.dataset.alt || "";
        });
      });
    });
  }

  /* ---------- variant picker (only when the product has options) ---------- */
  function initVariant(root) {
    $$("[data-variant-select]", root).forEach(function (sel) {
      sel.addEventListener("change", function () {
        var opt = sel.options[sel.selectedIndex];
        var r = sel.closest("[data-product-root]") || doc;
        var price = $("[data-price]", r),
          cmp = $("[data-compare]", r),
          atcPrice = $("[data-atc-price]", r);
        if (price) price.textContent = opt.dataset.price;
        if (atcPrice) atcPrice.textContent = opt.dataset.price;
        if (cmp) {
          cmp.textContent = opt.dataset.compare;
          cmp.hidden = !opt.dataset.compare;
        }
      });
    });
  }

  /* ---------- cart ---------- */
  var drawer = $("#CartDrawer");
  var lastFocus = null;

  function sectionIds() {
    var ids = [];
    if (drawer) ids.push("cart-drawer");
    var page = $("[data-cart-page]");
    if (page) ids.push(page.dataset.section);
    return ids;
  }

  function setCount(n) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = n;
      el.hidden = !n;
    });
  }

  function renderSections(sections) {
    if (!sections) return;
    if (sections["cart-drawer"] && drawer) {
      var d = new DOMParser().parseFromString(
        sections["cart-drawer"],
        "text/html",
      );
      var fresh = $("#CartDrawer", d);
      if (fresh) {
        $(".panel", drawer).innerHTML = $(".panel", fresh).innerHTML;
        var inner = $("#CartDrawerInner", drawer);
        if (inner) setCount(+inner.dataset.cartCountValue || 0);
        fxApply(drawer);
        keepTier();
      }
    }
    var page = $("[data-cart-page]");
    if (page && sections[page.dataset.section]) {
      var p = new DOMParser().parseFromString(
        sections[page.dataset.section],
        "text/html",
      );
      var src = $("#MainCartInner", p),
        dst = $("#MainCartInner");
      if (src && dst) dst.innerHTML = src.innerHTML;
    }
  }

  function openDrawer() {
    if (!drawer) return;
    lastFocus = doc.activeElement;
    drawer.classList.add("open");
    drawer.setAttribute("aria-hidden", "false");
    doc.body.classList.add("lock");
    var panel = $(".panel", drawer);
    if (panel)
      setTimeout(function () {
        panel.focus();
      }, 50);
  }
  function closeDrawer() {
    if (!drawer || !drawer.classList.contains("open")) return;
    drawer.classList.remove("open");
    drawer.setAttribute("aria-hidden", "true");
    doc.body.classList.remove("lock");
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshCart(open) {
    var ids = sectionIds();
    var url =
      ((O.routes && O.routes.root) || "/") + "?sections=" + ids.join(",");
    return fetch(url)
      .then(function (r) {
        return r.json();
      })
      .then(function (s) {
        renderSections(s);
        if (open) openDrawer();
      });
  }
  O.refreshCart = refreshCart;
  O.openCart = function () {
    refreshCart(true);
  };

  function afterAdd(sections) {
    if (O.cartType === "checkout") {
      location.href = "/checkout";
      return;
    }
    if (O.cartType === "page" || !drawer) {
      location.href = O.routes.cart;
      return;
    }
    renderSections(sections);
    openDrawer();
  }

  function initProductForms(root) {
    $$("form[data-product-form]", root).forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = $("[data-atc]", form);
        var err = $("[data-form-error]", form);
        if (btn) btn.classList.add("is-loading");
        if (err) err.textContent = "";
        var fd = new FormData(form);
        var ids = sectionIds();
        if (ids.length) {
          fd.append("sections", ids.join(","));
          fd.append("sections_url", location.pathname);
        }
        fetch(O.routes.cartAdd + ".js", {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: fd,
        })
          .then(function (r) {
            return r.json().then(function (j) {
              return { ok: r.ok, j: j };
            });
          })
          .then(function (res) {
            if (!res.ok || res.j.status)
              throw new Error(
                res.j.description || res.j.message || O.strings.error,
              );
            if (O.cartType === "drawer" && drawer && !res.j.sections)
              return refreshCart(true);
            afterAdd(res.j.sections);
            doc.dispatchEvent(new CustomEvent("cart:added", { detail: res.j }));
          })
          .catch(function (ex) {
            if (err) err.textContent = ex.message || O.strings.error;
            toast(ex.message || O.strings.error);
          })
          .finally(function () {
            if (btn) btn.classList.remove("is-loading");
          });
      });
    });
  }

  /* Secondary "Add to cart" buttons (final banner, sticky bar) submit the
     main buy-box form, so whatever a bundle app put in it is respected. */
  doc.addEventListener("click", function (e) {
    var proxy = e.target.closest("[data-atc-proxy]");
    if (!proxy) return;
    var form = $("form[data-product-form]");
    if (!form) {
      location.href = (O.routes.root || "/") + "#buy";
      return;
    }
    e.preventDefault();
    var btn = $("[data-atc]", form);
    if (form.requestSubmit) form.requestSubmit(btn || undefined);
    else if (btn) btn.click();
  });

  function changeLine(line, qty, el) {
    var host = el && (el.closest(".lines") || el.closest("#MainCartInner"));
    if (host) host.classList.add("is-updating");
    return fetch(O.routes.cartChange + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        line: line,
        quantity: qty,
        sections: sectionIds(),
        sections_url: location.pathname,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (j) {
        if (j.status) throw new Error(j.description || j.message);
        renderSections(j.sections);
        setCount(j.item_count);
      })
      .catch(function (ex) {
        toast(ex.message || O.strings.error);
      })
      .finally(function () {
        if (host) host.classList.remove("is-updating");
      });
  }

  /* ---------- strap bundle ----------
     Kaching prices straps by count (tiers from #CartDrawerInner[data-bundle]: e.g. 1 = £29,
     2 = Buy 1 Get 1 £39, 4 = Buy 2 Get 2 £59) and only makes the gifts free when they share the
     straps' bundle id. setTier(n) swaps the straps + bundle gifts for a clean tier-n bundle with the
     gifts that tier earns; n = 0 removes them. A count between tiers (e.g. 3) is moved up to the next
     tier when that tier does not cost more. */
  var bundleBusy = false;
  function bundleCfg() {
    var el = $("#CartDrawerInner");
    try {
      return el ? JSON.parse(el.dataset.bundle) : null;
    } catch (ex) {
      return null;
    }
  }
  function kbOf(item) {
    try {
      return JSON.parse((item.properties || {}).__kaching_bundles || "{}");
    } catch (ex) {
      return {};
    }
  }
  function setTier(n) {
    var cfg = bundleCfg();
    if (!cfg || !cfg.strap || bundleBusy) return Promise.resolve();
    n = Math.max(0, Math.min(n, (cfg.qty || []).length));
    bundleBusy = true;
    var host = $("#CartDrawer .cd-body");
    if (host) host.classList.add("is-updating");
    var json = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };
    return fetch(O.routes.cart + ".js")
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        /* the shopper's market has its own Kaching deal (cfg.market); fall back to the section setting */
        var mk = cfg.market || {},
          updates = {},
          deal = mk.deal || cfg.deal,
          v = mk.v || cfg.v;
        cart.items.forEach(function (it) {
          var kb = kbOf(it);
          if (it.product_id === cfg.pp || kb.gift) {
            updates[it.key] = 0;
            /* a newer version of the same deal, written by Kaching itself */
            if (kb.deal === deal && kb.v) v = kb.v;
          }
        });
        return fetch(O.routes.root + "cart/update.js", {
          method: "POST",
          headers: json,
          body: JSON.stringify({ updates: updates }),
        }).then(function () {
          if (n < 1) return;
          var id = Math.random().toString(36).slice(2, 6);
          var props = {
            deal: deal,
            pp: cfg.pp,
            main: true,
            v: v,
            id: id,
            bid: (mk.bars && mk.bars[n - 1]) || "bar-" + n,
          };
          if (mk.market) props.market = mk.market;
          var items = [
            {
              id: cfg.strap,
              quantity: cfg.qty[n - 1],
              properties: { __kaching_bundles: JSON.stringify(props) },
            },
          ];
          (cfg.gifts || []).forEach(function (g) {
            if (n >= g.at)
              items.push({
                id: g.id,
                quantity: 1,
                properties: {
                  __kaching_bundles: JSON.stringify({
                    id: id,
                    deal: deal,
                    v: v,
                    gift: g.gift,
                  }),
                },
              });
          });
          return fetch(O.routes.cartAdd + ".js", {
            method: "POST",
            headers: json,
            body: JSON.stringify({ items: items }),
          });
        });
      })
      .then(function () {
        bundleBusy = false;
        return refreshCart(false);
      })
      .catch(function (ex) {
        bundleBusy = false;
        toast((ex && ex.message) || O.strings.error);
        return refreshCart(false);
      });
  }
  O.setTier = setTier;
  var lifted = 0;
  function keepTier() {
    var inner = $("#CartDrawerInner"),
      cfg = bundleCfg();
    if (!inner || !cfg || bundleBusy || !cfg.qty) return;
    var q = +inner.dataset.strapQ || 0,
      total = +inner.dataset.strapTotal || 0;
    if (!q || cfg.qty.indexOf(q) > -1) {
      lifted = 0;
      return;
    }
    for (var i = 0; i < cfg.qty.length; i++) {
      if (cfg.qty[i] > q) {
        if ((cfg.fx ? fxCents(cfg.prices[i] * 100) : Math.round(cfg.prices[i] * 100)) <= total && lifted < 2) {
          lifted++;
          setTier(i + 1);
        }
        return;
      }
    }
  }

  /* ---------- shipping protection switch (cart drawer) ---------- */
  doc.addEventListener("change", function (e) {
    var sw = e.target.closest("[data-protect]");
    if (!sw) return;
    var id = +sw.dataset.protect,
      on = sw.checked,
      foot = sw.closest(".cd-foot");
    if (foot) foot.classList.add("is-updating");
    var req = on
      ? fetch(O.routes.cartAdd + ".js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
        })
      : fetch(O.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            updates: (function (u) {
              u[id] = 0;
              return u;
            })({}),
          }),
        });
    req
      .then(function () {
        return refreshCart(false);
      })
      .catch(function (ex) {
        sw.checked = !on;
        if (foot) foot.classList.remove("is-updating");
        toast((ex && ex.message) || O.strings.error);
      });
  });

  /* ---------- cart upsell (cart drawer "Pairs well with your strap") ---------- */
  doc.addEventListener("change", function (e) {
    if (e.target.name !== "cd-ups-v") return;
    var box = e.target.closest("[data-upsell]"),
      img = box && $("[data-upsell-img]", box);
    if (img && e.target.dataset.img) {
      img.removeAttribute("srcset");
      img.src = e.target.dataset.img;
    }
  });
  doc.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-upsell-add]");
    if (!btn) return;
    e.preventDefault();
    var box = btn.closest("[data-upsell]"),
      v =
        $('input[name="cd-ups-v"]:checked', box) ||
        $('input[name="cd-ups-v"]', box);
    if (!v) return;
    btn.classList.add("is-loading");
    fetch(O.routes.cartAdd + ".js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: [{ id: +v.value, quantity: 1 }] }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (j) {
        if (j.status) throw new Error(j.description || j.message);
        return refreshCart(false);
      })
      .catch(function (ex) {
        btn.classList.remove("is-loading");
        toast((ex && ex.message) || O.strings.error);
      });
  });

  doc.addEventListener("click", function (e) {
    var ts = e.target.closest("[data-tier-set]");
    if (ts && !ts.disabled) {
      e.preventDefault();
      setTier(+ts.dataset.tierSet);
      return;
    }
  });

  doc.addEventListener("click", function (e) {
    var open = e.target.closest("[data-cart-open]");
    if (open && drawer && O.cartType === "drawer" && !$("[data-cart-page]")) {
      e.preventDefault();
      refreshCart(true);
      return;
    }
    if (e.target.closest("[data-drawer-close]")) {
      closeDrawer();
      return;
    }

    var step = e.target.closest("[data-qty-step]");
    var rm = e.target.closest("[data-remove]");
    if (step || rm) {
      var line = e.target.closest("[data-line]");
      if (!line) return;
      e.preventDefault();
      var input = $("[data-line-qty]", line);
      var q = rm ? 0 : Math.max(0, (+input.value || 0) + +step.dataset.qtyStep);
      changeLine(+line.dataset.line, q, line);
    }
  });
  doc.addEventListener("change", function (e) {
    if (e.target.matches("[data-line-qty]")) {
      var line = e.target.closest("[data-line]");
      if (line)
        changeLine(+line.dataset.line, Math.max(0, +e.target.value || 0), line);
    }
    if (e.target.matches("[data-sort-select]")) {
      var u = new URL(location.href);
      u.searchParams.set("sort_by", e.target.value);
      location.href = u.toString();
    }
  });
  doc.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  /* Bundle apps and other scripts can ask the theme to refresh its cart UI. */
  doc.addEventListener("cart:refresh", function () {
    refreshCart(false);
  });

  /* ---------- Kaching bundle bars: gift list + "+N FREE" thumbnail ----------
     Reads the deal (dealBars, progressiveGifts) from Kaching's own settings script in the block,
     so the gift list follows whatever is set in Kaching. Each bar gets a gift list (shown in full on
     the selected bar, as one summary line on the others — CSS). "Worth" = the gift product's price
     in the shopper's currency; free shipping is worth the market's paid delivery rate. Gift images come from Kaching's gift list
     (same order as progressiveGifts.gifts). Kaching re-renders bars on selection; an observer
     puts the extras back. */
  function kachingGifts() {
    var slot = $("#BundleSlot");
    if (!slot || slot.dataset.kg) return;
    var cfgEl = $("script.kaching-bundles-deal-block-settings", slot);
    if (!cfgEl) return;
    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (ex) {
      return;
    }
    var products = {};
    $$("script.kaching-bundles-product", slot).forEach(function (s) {
      try {
        var j = JSON.parse(s.textContent);
        products[j.id] = j;
      } catch (ex) {}
    });
    var mainImg = (products[(cfg.selectedProductIds || [])[0]] || {}).image;
    /* "The Knee & Leg Longevity Guide (Digital PDF)" → "Knee & Leg Longevity Guide",
       "Onestrap Gift Card" → "Gift Card", "Free shipping" → "Shipping" */
    function giftName(t, ship) {
      t = String(t || "")
        .replace(/\s*\([^)]*\)\s*$/, "")
        .replace(/^the\s+/i, "")
        .replace(/^onestrap\s+/i, "")
        .replace(/^free\s+/i, "");
      return t.charAt(0).toUpperCase() + t.slice(1);
    }
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || O.baseCurrency || "GBP";
    function money(cents) {
      var s;
      try {
        s = new Intl.NumberFormat(FX_LOCALE[cur] || "en", { style: "currency", currency: cur }).format(cents / 100);
      } catch (e) {
        s = (cents / 100).toFixed(2);
      }
      return s.replace(/\.00$/, "");
    }
    function moneyFull(cents) {
      try {
        return new Intl.NumberFormat(FX_LOCALE[cur] || "en", { style: "currency", currency: cur }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2);
      }
    }
    /* Struck-through figure = the whole bar at full price: its straps + the gifts it includes, labelled
       "total value" (the price next to it may be per strap). Save % compares like with like: the bar's
       total price against that total value. Kaching's element is hidden and a copy carries our figure,
       so Kaching can keep re-rendering it. */
    function strikeWithGifts(bar, deal, giftCents) {
      var fp = $(".kaching-bundles__bar-full-price:not(.os-full)", bar);
      if (!fp) return;
      var copy = $(".os-full", bar);
      if (!giftCents) {
        if (copy) copy.remove();
        fp.style.display = "";
        return;
      }
      var orig = fp.textContent.trim();
      if (copy && copy.dataset.orig === orig) return;
      var unit = Math.round((parseFloat(orig.replace(/[^0-9.]/g, "")) || 0) * 100);
      if (!unit) return;
      var straps = deal.dealBarType === "bxgy" ? (deal.buyQuantity || 0) + (deal.getQuantity || 0) : deal.quantity || 1;
      var per = cfg.showPricesPerItem ? straps : 1;
      var value = unit * per + giftCents;
      var pr = $(".kaching-bundles__bar-price", bar),
        paid = Math.round((parseFloat(((pr && pr.textContent) || "").replace(/[^0-9.]/g, "")) || 0) * 100) * per;
      if (!copy) {
        copy = fp.cloneNode(false);
        copy.classList.add("os-full");
        copy.removeAttribute("data-a11y-label");
        fp.parentNode.insertBefore(copy, fp.nextSibling);
      }
      copy.dataset.orig = orig;
      copy.dataset.amount = moneyFull(value);
      copy.dataset.save = paid && paid < value ? Math.round(((value - paid) / value) * 100) : "";
      copy.innerHTML = "<s>" + esc(copy.dataset.amount) + "</s><small>total value</small>";
      copy.setAttribute("aria-label", "Total value with gifts: " + copy.dataset.amount);
      fp.style.display = "none";
    }
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) {
        return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
      });
    }
    var gifts = ((cfg.progressiveGifts || {}).gifts || []).map(function (g) {
      var pid = g.productGID ? +g.productGID.split("/").pop() : null;
      var p = pid && products[pid];
      var title =
        g.giftType === "shipping"
          ? g.title || "Free shipping"
          : (p && p.title) || g.title || "";
      var v = p && p.variants && p.variants[0];
      return {
        at: g.unlockAtBar || 1,
        only: g.unlockAtBarOnly,
        title: title,
        name: giftName(title, g.giftType === "shipping"),
        /* shipping is worth the market's paid delivery rate (snippets/delivery-info → data-ship-rate) */
        worth: g.giftType === "shipping" ? +slot.dataset.shipRate || 0 : (v && v.price) || 0,
        ship: g.giftType === "shipping",
        img: null,
      };
    });
    /* Same pictures as Kaching's own "Free gifts" list (it renders the gifts in config order). */
    function giftImages() {
      var imgs = $$(".kaching-bundles__progressive-gifts__gift img", slot);
      gifts.forEach(function (g, i) {
        /* the delivery picture is mostly background at circle size, so a close crop of it is used */
        if (g.ship && slot.dataset.shipIcon) g.img = slot.dataset.shipIcon;
        else if (imgs[i]) g.img = imgs[i].getAttribute("src");
      });
      return gifts.every(function (g) {
        return g.img;
      });
    }
    /* Buy-box price row follows the selected Kaching bar (its price and struck-through full price). */
    function syncPrice() {
      var root = slot.closest("[data-product-root]"),
        row = root && $("[data-price-row]", root),
        sel = $(".kaching-bundles__bar--selected", slot);
      if (!row || !sel) return;
      var now = $(".kaching-bundles__bar-price", sel),
        full = $(".os-full", sel) || $(".kaching-bundles__bar-full-price", sel),
        pEl = $("[data-price]", row),
        cEl = $("[data-compare]", row),
        sEl = $("[data-save]", row);
      if (!now || !pEl) return;
      var num = function (el) {
        return el ? parseFloat(el.textContent.replace(/[^0-9.]/g, "")) || 0 : 0;
      };
      var a = num(now),
        b = num(full),
        txt = now.textContent.trim();
      /* "per item" mode adds a unit after the amount ("$26.05 per strap"): keep it small */
      if (pEl.dataset.v !== txt) {
        pEl.dataset.v = txt;
        var m = txt.match(/^([^0-9]*[0-9][0-9.,]*)\s*(.*)$/);
        pEl.textContent = m ? m[1] : txt;
        if (m && m[2]) {
          var u = doc.createElement("small");
          u.textContent = " " + m[2];
          pEl.appendChild(u);
        }
      }
      var fullTxt = (full && (full.dataset.amount || full.textContent.trim())) || "",
        fixedSave = full && full.dataset.save;
      if (full && full.dataset.amount) b = num({ textContent: fullTxt });
      var show = b > a;
      if (cEl) {
        cEl.hidden = !show;
        if (show && cEl.textContent !== fullTxt) cEl.textContent = fullTxt;
        var tv = cEl.nextElementSibling;
        if (!tv || !tv.classList.contains("os-tv")) {
          tv = doc.createElement("small");
          tv.className = "os-tv";
          tv.textContent = "total value";
          cEl.parentNode.insertBefore(tv, cEl.nextSibling);
        }
        tv.hidden = !(show && full && full.dataset.amount);
      }
      if (sEl) {
        sEl.hidden = !show;
        if (show) {
          var t = (row.dataset.saveLabel || "Save [percent]%").replace(
            "[percent]",
            fixedSave || Math.round(((b - a) / b) * 100),
          );
          if (sEl.textContent !== t) sEl.textContent = t;
        }
      }
    }
    function apply() {
      syncPrice();
      if (!giftImages()) return;
      $$("label.kaching-bundles__bar-container", slot).forEach(
        function (bar, i) {
          var deal = (cfg.dealBars || [])[i];
          if (!deal) return;
          var n = i + 1;
          var mine = gifts.filter(function (g) {
            return g.only ? g.at === n : g.at <= n;
          });
          var total = mine.reduce(function (s, g) {
            return s + g.worth;
          }, 0);
          var valueTxt = total ? money(total) : "";
          var left = $(".kaching-bundles__bar-content-left", bar);
          if (left && mine.length && !$(".os-kg", left)) {
            var sum = doc.createElement("div");
            sum.className = "os-kg";
            sum.textContent = "+ " + mine.length + " free gift" + (mine.length > 1 ? "s" : "");
            left.appendChild(sum);
          }
          strikeWithGifts(bar, deal, total);
          var wrap = $(".kaching-bundles__bar-wrapper", bar);
          if (wrap && mine.length && !$(".os-gl", wrap)) {
            var gl = doc.createElement("div");
            gl.className = "os-gl";
            gl.innerHTML =
              '<p class="os-gl-h"><b>+ Free gift' + (mine.length > 1 ? "s" : "") + " with your order</b>" +
              (valueTxt ? '<span class="os-gl-v">' + esc(valueTxt) + " value</span>" : "") + "</p><ul>" +
              mine
                .map(function (g) {
                  return (
                    '<li><span class="os-gl-img"><img src="' + esc(g.img) + '" alt="" width="52" height="52" loading="lazy"></span>' +
                    '<span class="os-gl-t"><b><em>FREE</em> ' + esc(g.name) + "</b>" +
                    (g.worth ? "<i>Worth " + esc(money(g.worth)) + "</i>" : "") + "</span></li>"
                  );
                })
                .join("") +
              "</ul>";
            wrap.appendChild(gl);
          }
          var main = $(".kaching-bundles__bar-main", bar);
          var free = deal.dealBarType === "bxgy" ? deal.getQuantity || 0 : 0;
          /* a bar image set in Kaching (X1/X2/X4) replaces our thumbnail */
          if (main && $(".kaching-bundles__bar-image", main)) {
            var old = $(".os-kthumb", main);
            if (old) old.remove();
          } else if (main && mainImg && !$(".os-kthumb", main)) {
            var th = doc.createElement("span");
            th.className = "os-kthumb";
            th.innerHTML =
              '<img src="' +
              mainImg +
              '" alt="" loading="lazy" width="56" height="56">' +
              (free ? "<b>+" + free + " FREE</b>" : "");
            var content = $(".kaching-bundles__bar-content", main);
            main.insertBefore(th, content);
          }
        },
      );
    }
    slot.dataset.kg = "1";
    apply();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(apply, 30);
    }).observe(slot, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["class"],
    });
    slot.addEventListener("change", function () {
      setTimeout(syncPrice, 50);
    });
    slot.addEventListener("click", function () {
      setTimeout(syncPrice, 80);
    });
  }
  if ($("#BundleSlot")) {
    if (doc.readyState === "complete") kachingGifts();
    else window.addEventListener("load", kachingGifts);
    setTimeout(kachingGifts, 2500);
  }

  /* ---------- customer login: reveal password reset ---------- */
  doc.addEventListener("click", function (e) {
    var t = e.target.closest("[data-toggle-recover]");
    if (!t) return;
    e.preventDefault();
    var r = $("#recover");
    if (r) r.scrollIntoView({ behavior: reduced ? "auto" : "smooth" });
  });

  /* ---------- scroll: progress bar + sticky add-to-cart ---------- */
  var prog = $("#ScrollProgress");
  var ticking = false;
  function onScroll() {
    ticking = false;
    var y = window.scrollY,
      h = doc.documentElement.scrollHeight - window.innerHeight;
    if (prog)
      prog.style.width = (h > 0 ? Math.min(100, (y / h) * 100) : 0) + "%";
    var bar = $("[data-sticky]"),
      atc = $("#ProductSubmit");
    if (bar && atc) {
      var up = atc.getBoundingClientRect().bottom < 60;
      if (up !== bar.classList.contains("up")) {
        bar.classList.toggle("up", up);
        bar.setAttribute("aria-hidden", up ? "false" : "true");
        $$("button", bar).forEach(function (b) {
          b.tabIndex = up ? 0 : -1;
        });
        doc.body.classList.toggle("has-sticky", up);
      }
    }
  }
  window.addEventListener(
    "scroll",
    function () {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(onScroll);
      }
    },
    { passive: true },
  );
  window.addEventListener("resize", onScroll);

  /* ---------- boot + theme editor ---------- */
  function boot(root) {
    observeReveal(root);
    observeCounters(root);
    observeVideos(root);
    initGallery(root);
    initVariant(root);
    initProductForms(root);
  }
  boot(doc);
  onScroll();

  doc.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
    syncTop();
    onScroll();
  });
  doc.addEventListener("shopify:section:select", function (e) {
    $$(".rv", e.target).forEach(function (el) {
      el.classList.add("in");
    });
  });
})();
